import { render, staticRenderFns } from "./shareImg.vue?vue&type=template&id=2fa0bcfe&scoped=true&"
import script from "./shareImg.vue?vue&type=script&lang=js&"
export * from "./shareImg.vue?vue&type=script&lang=js&"
import style0 from "./shareImg.vue?vue&type=style&index=0&id=2fa0bcfe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fa0bcfe",
  null
  
)

export default component.exports